export const USER_NOT_FOUND = 'UserNotFoundException';
export const DEVICES_LIMIT_REACHED = 'DEVICES_LIMIT_REACHED';
export const DEALER_ALREADY_USED = 'DEALER_CONFIG_VALUE_ALREADY_USED';
